import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminDashboard.css';

// Admin Components
import AdminHome from './AdminHome';
import Scoli from './Scoli';
import Gradinite from './Gradinite';
import Clase from './Clase';
import Meniu from './Meniu';
import Comenzi from './Comenzi';
import Utilizatori from './Utilizatori';

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('home');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>🍽️ Gradi Admin</h2>
          <p className="user-info">{user?.nume}</p>
        </div>

        <nav className="sidebar-menu">
          <Link
            to="/admin"
            className={activeMenu === 'home' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('home')}
          >
            <span>📊</span> Dashboard
          </Link>
          
          <Link
            to="/admin/scoli"
            className={activeMenu === 'scoli' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('scoli')}
          >
            <span>🏫</span> Scoli
          </Link>

          <Link
            to="/admin/gradinite"
            className={activeMenu === 'gradinite' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('gradinite')}
          >
            <span>🎀</span> Gradinite
          </Link>

          <Link
            to="/admin/clase"
            className={activeMenu === 'clase' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('clase')}
          >
            <span>👶</span> Clase
          </Link>

          <Link
            to="/admin/meniu"
            className={activeMenu === 'meniu' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('meniu')}
          >
            <span>🍴</span> Meniu
          </Link>

          <Link
            to="/admin/comenzi"
            className={activeMenu === 'comenzi' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('comenzi')}
          >
            <span>📝</span> Comenzi
          </Link>

          <Link
            to="/admin/utilizatori"
            className={activeMenu === 'utilizatori' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('utilizatori')}
          >
            <span>👥</span> Utilizatori
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="btn btn-danger btn-block">
            Deconectare
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Routes>
          <Route path="/" element={<AdminHome />} />
          <Route path="/scoli" element={<Scoli />} />
          <Route path="/gradinite" element={<Gradinite />} />
          <Route path="/clase" element={<Clase />} />
          <Route path="/meniu" element={<Meniu />} />
          <Route path="/comenzi" element={<Comenzi />} />
          <Route path="/utilizatori" element={<Utilizatori />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminDashboard;
